import React, {useEffect} from "react";
import "./BottomBar.css";
import {useHistory, useLocation} from "react-router";


export const BottomBar = () => {

    let history = useHistory();
    let location = useLocation();

    useEffect(() => {
    }, []);

    if (window.location.pathname.startsWith("/monitor") ||
        window.location.pathname.startsWith("/terraforming") ||
        window.location.pathname.startsWith("/throughTheAges") ||
        window.location.pathname.startsWith("/megawatt") ||
        window.location.pathname.startsWith("/arknova") ||
        window.location.pathname.startsWith("/anniv") ||
        window.location.pathname.startsWith("/tu") ||
        window.location.pathname.startsWith("/symetry") ||
        window.location.pathname.startsWith("/test") ||
        window.location.pathname.startsWith("/lobby") ||
        window.location.pathname.startsWith("/generated") ||
        window.location.pathname.startsWith("/7Wonders")) {
        return undefined;
    }

    return (
        <div className={"navbar"}>
            <div>
                <a href="/killing-zeus">
                    Killing&nbsp;Zeus
                </a> - <a href="/ultra-myth">
                RTS&nbsp;Ultra&nbsp;Myth
            </a> - <a href="/confidentiality">
                Confidentiality&nbsp;policy
            </a> - <a href="/legalterms2">
                Puzzle Piece
            </a> - <a href="/legalterms">
                Legal&nbsp;terms
            </a> - <a href="/">
                welcomegames.fr
            </a>
            </div>
            <div style={{marginTop: "5px"}}>
                Welcome Games - December 2023
            </div>
        </div>
    );
};

export default BottomBar;
